"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.gzip = void 0;
const zlib_1 = require("zlib");
const globParent = require("glob-parent");
const fileUtils_1 = require("./fileUtils");
const generatorUtils_1 = require("./generatorUtils");
const defaultParams = {
    outputDir: null,
    outputExtensions: ['gz']
};
function gzip(runParams) {
    const params = { ...defaultParams, ...runParams };
    if (params.outputDir) {
        fileUtils_1.default.ensureOutputDir(params.outputDir);
    }
    return generatorUtils_1.default.execute(handlePatterns(params));
}
exports.gzip = gzip;
function compressFile(filePath, outputFilePath, outputExtension) {
    if (Array.isArray(outputExtension)) {
        return Promise.all(outputExtension.map(extension => compressFile(filePath, outputFilePath, extension)));
    }
    const outputFilePathWitExtension = `${outputFilePath}.${outputExtension}`;
    const compressionMethod = outputExtension === 'br' ? zlib_1.createBrotliCompress : zlib_1.createGzip;
    return new Promise(resolve => {
        fileUtils_1.default.getReadStream(filePath)
            .pipe(compressionMethod())
            .pipe(fileUtils_1.default.getWriteStream(outputFilePathWitExtension))
            .on('finish', resolve);
    });
}
function* handlePatterns(runParams) {
    for (let i = 0; i < runParams.patterns.length; i++) {
        yield* compressPattern(runParams.patterns[i], runParams);
    }
}
function* compressPattern(pattern, runParams) {
    const filePaths = yield fileUtils_1.default.getFilePathsFromGlob(pattern, runParams);
    const globBase = globParent(pattern);
    for (let i = 0; i < filePaths.length; i++) {
        const filePath = filePaths[i];
        const outputFilePath = fileUtils_1.default.getOutputFilePath(filePath, runParams, globBase);
        yield compressFile(filePath, outputFilePath, runParams.outputExtensions);
    }
}
